// Quick Focused Items are meant to complement Focused Items. As the name implies,
// the difference is that these should be quickly, and temporarily, applied. At time
// of implementation, this is meant to be used for showing item footprints when the
// footprint button is hovered, without conflicting with the main Focused Items

import {createReducer} from '@reduxjs/toolkit';

import {applyFilters} from '../actions/item-filters.js';
import {
  quickFocusItems,
  quickUnfocusAllItems,
} from '../actions/quick-focused-item.js';
import {
  clearSearch,
  executeSearch,
  loadSearch,
  searchSingleItem,
} from '@explorer/actions/search';

export const initialState = [];

const quickFocusedItems = createReducer(initialState, builder => {
  builder.addCase(quickFocusItems, (_, {payload: {items}}) => {
    return Array.isArray(items) ? items : [items];
  });

  builder.addCase(quickUnfocusAllItems, () => initialState);
  builder.addCase(loadSearch, () => initialState);
  builder.addCase(clearSearch, () => initialState);
  builder.addCase(executeSearch, () => initialState);
  builder.addCase(searchSingleItem, () => initialState);
  builder.addCase(applyFilters, () => initialState);
});

export default quickFocusedItems;
